export default __webpack_public_path__ + "static/media/insect.2dcf971a.svg";